<template>
  <v-card tile v-if="vehicle !== null">
    <v-card-title>
      <v-row>
        <v-col
            cols="12"
            class="d-flex justify-space-between"
        >
          <span>Vozilo</span>
          <v-btn icon @click="editable = true" v-if="editable === false">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="save" v-else>
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-form :readonly="!editable">
            <h1>
              <v-text-field
                  label="Registrska tablica"
                  v-model="vehicle.registration_plate"
              ></v-text-field>
            </h1>
            <v-text-field
                label="Proizvajalec"
                v-model="vehicle.manufacturer"
            ></v-text-field>
            <v-text-field label="Model" v-model="vehicle.model"></v-text-field>
            <v-autocomplete
                v-model="vehicle.employee_id"
                :items="employees"
                :search-input.sync="employeeSearch"
                @click="loadEmployees"
                item-text="first_name"
                item-value="id"
                label="Voznik"
                :clearable="editable"
            >
              <template v-slot:item="{ item }">
                {{ item.first_name }} {{ item.last_name }}
              </template>
              <template v-slot:selection="{ item }">
                {{ item.first_name }} {{ item.last_name }}
              </template>
            </v-autocomplete>
            <v-text-field label="Lastnik" v-model="vehicle.owner"></v-text-field>
            <v-text-field label="Vrsta" v-model="vehicle.type"></v-text-field>
            <v-text-field label="Pogodba" v-model="vehicle.contract"></v-text-field>

            <v-menu
                v-model="dpRegisteredMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="editable === false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="vehicle.registered_until"
                    label="Registriran do"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :clearable="editable === true"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="vehicle.registered_until"
                  @input="dpRegisteredMenu = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
                v-model="dpInsuredMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="editable === false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="vehicle.insured_until"
                    label="Zavarovan do"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :clearable="editable === true"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="vehicle.insured_until"
                  @input="dpInsuredMenu = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
                v-model="dpSVMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="editable === false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="vehicle.slovenian_vignette"
                    label="Slovenska vinjeta do"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :clearable="editable === true"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="vehicle.slovenian_vignette"
                  @input="dpSVMenu = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
                v-model="dpAVMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="editable === false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="vehicle.austrian_vignette"
                    label="Avstrijska vinjeta do"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :clearable="editable === true"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="vehicle.austrian_vignette"
                  @input="dpAVMenu = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
                v-model="dpTunnelsMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="editable === false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="vehicle.tunnels"
                    label="Tuneli do"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :clearable="editable === true"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="vehicle.tunnels"
                  @input="dpTunnelsMenu = false"
              ></v-date-picker>
            </v-menu>
            <v-text-field label="Komentar" v-model="vehicle.comment"></v-text-field>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    vehicle: null,
    editable: false,
    employees: [],
    employeeSearch: "",

    dpRegisteredMenu: null,
    dpInsuredMenu: null,
    dpSVMenu: null,
    dpAVMenu: null,
    dpTunnelsMenu: null,
  }),
  mounted() {
    this.loadVehicle();
  },
  methods: {
    loadVehicle() {
      this.$http
          .get("api/v1/vehicles/" + this.$route.params.id)
          .then((response) => {
            this.vehicle = response.data;
            if (response.data.employee_id !== null) {
              this.employees.push(response.data.employee);
            }
          });
    },
    loadEmployees() {
      if (this.editable === false || this.employeeSearch === null) {
        return;
      }
      this.$http
          .get("api/v1/employees", {
            params: {
              search: encodeURI("%" + this.employeeSearch + "%"),
            },
          })
          .then((response) => {
            this.employees = response.data.data;
          });
    },
    save() {
      this.$http
          .put("api/v1/vehicles/" + this.$route.params.id, this.vehicle)
          .then((response) => {
            this.vehicle = response.data;
            this.editable = false;
          });
    },
  },
  watch: {
    employeeSearch() {
      this.loadEmployees();
    },
  },
};
</script>
<style></style>
